/**
 * UsageFieldButton - Concrete usage field button using existing hooks
 */

import {useUsage} from '@hconnect/tuc-processes/fields/usage/useUsage'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

interface UsageFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const UsageFieldButton: React.FC<UsageFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {usage} = useUsage()

  // Following useRmcOrderEditLogic withFallback pattern
  const trimmed = usage?.toString().trim()
  const displayValue = trimmed && trimmed.length > 0 ? trimmed : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.usage', 'Usage')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
